var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainNavFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.223 6c.455 0 .91.171 1.257.511a1.725 1.725 0 010 2.468l-5.334 5.236a1.802 1.802 0 01-2.514 0L7.333 11.96l-2.299 2.256a1.8 1.8 0 01-2.514 0 1.724 1.724 0 010-2.468l3.556-3.49a1.802 1.802 0 012.514 0l2.299 2.256 4.077-4.002A1.79 1.79 0 0116.223 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNavFeed);
export default __webpack_public_path__ + "static/media/main-nav-feed.f5f06f08720c8e6ccf47bd5f0cb6b81a.svg";
export { ForwardRef as ReactComponent };